export const DEFAULT_MEAL_PRICE = 9_000;

export function parseMenuPrice(value: unknown): number | null {
  if (typeof value === "number") {
    return Number.isInteger(value) && value >= 0 ? value : null;
  }
  if (typeof value !== "string") return null;
  const normalized = value.trim().replace(/[,_\s원]/g, "");
  if (!normalized) return null;
  const price = Number(normalized);
  return Number.isInteger(price) && price >= 0 ? price : null;
}

export function resolveMenuPrice(value: unknown, fallback = DEFAULT_MEAL_PRICE): number | null {
  if (value === undefined || value === null || value === "") return fallback;
  return parseMenuPrice(value);
}
